<script>
  import { alert } from 'vue-strap';
  
  export default {
    components: { alert },
    props: {
      despesas: {
        type: Array,
        required: true,
      },
      utilizarMetaEtapaProjeto: {
        type: Boolean,
        required: true,
      },
      exibirRubricaSubrubricaSolicitacaoWeb: {
        type: Boolean,
        required: true,
      },
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    methods: {
      deletarItem(indice) {
        this.despesas.splice(indice, 1);
        this.$events.emit('desabilitarCompraDireta');
      },
    },
    beforeDestroy() {
      this.$events.off('desabilitarCompraDireta');
    },
    computed: {
      total: function() {
        return this.despesas.reduce((somatorio, item) => {
          const valor = this.$options.filters.formatarNumero(item.valor, true);

          return somatorio + valor;
        }, 0);
      }
    }
  }
</script>

<template>
  <div>
    <alert type="warning" v-if="despesas.length === 0">
      <i class="fa fa-warning"></i> Nenhuma despesa adicionada.
    </alert>
    
    <div class="bs-callout bs-callout-info no-margin-top" v-for="(despesa, index) in despesas">

      <h4>
        Item #{{ index + 1 }}

        <button type="button"
                class="btn btn-sm btn-danger btn-delete-item"
                title="Excluir item"
                @click="deletarItem(index)"
                v-if="!relatorio">
          <i class="fa fa-trash"></i>
        </button>
      </h4>

      <div class="row">
        <dl class="col-md-4">
          <dt>CPF/CNPJ</dt>
          <dd>{{ despesa.cpfCnpj || '---' }}</dd>
        </dl>
        <dl class="col-md-4">
          <dt>Nome</dt>
          <dd>{{ despesa.nome || '---' }}</dd>
        </dl>
        <dl class="col-md-4">
          <dt>Valor</dt>
          <dd>{{ despesa.valor }}</dd>
        </dl>
      </div>

      <div class="row">
        <dl class="col-md-4">
          <dt>Tipo documento</dt>
          <dd>{{ despesa.tipoDocumento || '---' }}</dd>
        </dl>
        <dl class="col-md-4">
          <dt>Nº do Documento/Nota</dt>
          <dd>{{ despesa.nota || '---' }}</dd>
        </dl>
        <dl class="col-md-4">
          <dt>Data</dt>
          <dd>{{ despesa.data || '---' }}</dd>
        </dl>
      </div>

      <div class="row" v-if="utilizarMetaEtapaProjeto && exibirRubricaSubrubricaSolicitacaoWeb">
        <dl class="col-md-12">
          <dt>Meta etapa</dt>
          <dd>{{ despesa.projetoMetaEtapa ? `${despesa.projetoMetaEtapa.meta.nome} - ${despesa.projetoMetaEtapa.etapa.nome}` : '---' }}</dd>
        </dl>
      </div>

      <div class="row" v-if="exibirRubricaSubrubricaSolicitacaoWeb">
        <dl class="col-md-6">
          <dt>Rubrica</dt>
          <dd>{{ despesa.rubrica ? despesa.rubrica.nome : '---' }}</dd>
        </dl>
        <dl class="col-md-6">
          <dt>Subrubrica</dt>
          <dd>{{ despesa.subrubrica ? despesa.subrubrica.nome : '---' }}</dd>
        </dl>
      </div>

      <div class="row">
        <dl class="col-md-12">
          <dt>Devoluções diversas?</dt>
          <dd>{{ despesa.devolucoesDiversas ? 'Sim' : 'Não' }}</dd>
        </dl>
      </div>

      <div class="row" v-if="despesa.observacao">
        <dl class="col-md-12">
          <dt>Observação</dt>
          <dd>{{ despesa.observacao || '---' }}</dd>
        </dl>
      </div>

    </div>

    <div class="bs-callout bs-callout-primary">
      <h4>Valor total: R$ {{ total | formatarNumero }}</h4>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-terceiro/componentes/compartilhado/FormListaDespesas.vue